export default __webpack_public_path__ + "static/media/20210103.78e71689.webp";